module.exports = __webpack_public_path__ + "c4bdb0f5167b3c9da2a51d74f52ce3b4.mp4";